export const tabStyle = (active) => ({
  fontFamily: "Plus Jakarta Sans",
  fontSize: "18px",
  fontWeight: active ? 700 : 600,
  borderBottom: active ? "2px solid #222" : "2px solid transparent",
  color: active ? "#222" : "#687B8E",
  background: "none",
  padding: "0 18px",
  minHeight: "38px",
  cursor: "pointer",
  borderRadius: 0,
  boxShadow: "none"
});

export const tabContainerStyle = {
  display: "flex",
  borderBottom: "1px solid #eee",
  mb: 3,
  gap: 0
};